import React, { useEffect } from "react";
import { Box, Heading, Text } from "grommet";
import { CourseList } from "../components/LearningPaths/CourseList";
import { useLocation, useNavigate } from "react-router-dom";
import { StickyFooter } from "../components/Footers/GlobalFooter";
import { HeaderNavigation } from "../components/Headers/GlobalHeader";
import { LinkPrevious } from "grommet-icons";
import API_URL from "../config/config";
import axios from "axios";
import { useState } from "react";
const LearningPathDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { path } = location.state;
  const [courses, setCourses] = useState([]);
  const [learninpathname, setLearningPathName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/dashboard/courses/${path.learningpath_id}`,
        );
        setCourses(response.data.courses);
        setLearningPathName(response.data.learningPathName);
        // Handle the response data here
      } catch (error) {
        // Handle the error here
      }
    };
    setSelectedCourse(path.id);

    fetchData();
  }, []);
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box fill="vertical" justify="between">
          <Box flex="grow" pad="medium" margin={{ horizontal: "large" }}>
            <Box alignSelf="start">
              <LinkPrevious onClick={handleBack} size="large" color="brand" />
            </Box>
            <Heading level="1">{learninpathname}</Heading>
            <Text size="medium" color="dark-3">
              We recommend you to take these courses to complete the learning
              path:
            </Text>
            {/* <Heading level="3" margin={{ vertical: "small" }}>
              {path.description}
            </Heading> */}
            <Box
              border={{ color: "brand", size: "xsmall" }}
              width="100%"
              //   margin={{ vertical: "medium" }}
            />

            <CourseList courses={courses} selectedCourse={selectedCourse} />
            {/* </Box> */}
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};
export default LearningPathDetails;
